import { Table } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const PageHeader = styled.header`
  margin-bottom: 24px;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const HeaderLeft = styled.div`
  flex: 1;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin: 0 0 4px 0;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin: 0;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SearchInput = styled.input`
  width: 280px;
  height: 40px;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1);
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.25);
  }

  @media (max-width: 768px) {
    flex: 1;
    width: auto;
  }
`;

export const CreateButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: var(--primary);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: var(--primary-dark, #096dd9);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const TableStyled = styled(Table)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-thead > tr > th {
    font-weight: 600;
    font-size: 13px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
  }

  .ant-table-tbody > tr > td {
    font-size: 14px;
    padding: 16px;
  }

  .ant-table-tbody > tr {
    cursor: pointer;
    transition: background 0.2s;

    &:hover > td {
      background: #fafafa !important;
    }
  }

  .ant-table-bordered {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
  }

  .ant-pagination {
    margin-top: 16px;
  }
`;

export const StatusBadge = styled.span<{ $status: 'pending' | 'completed' }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 12px;
  background: ${({ $status }) => ($status === 'completed' ? '#f6ffed' : '#fff7e6')};
  color: ${({ $status }) => ($status === 'completed' ? '#52c41a' : '#fa8c16')};
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;

  > svg {
    width: 64px;
    height: 64px;
    color: rgba(0, 0, 0, 0.15);
    margin-bottom: 16px;
  }

  h3 {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin: 0 0 8px 0;
  }

  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.45);
    margin: 0 0 24px 0;
  }
`;

export const DateCell = styled.span`
  color: rgba(0, 0, 0, 0.65);
`;

export const TypeBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
`;

export const ProtocolCell = styled.span`
  font-weight: 600;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.75);
  font-variant-numeric: tabular-nums;
`;

export const SummaryCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SummaryMain = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
`;

export const SummarySub = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 320px;
`;

export const AttachmentBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: rgba(0, 0, 0, 0.35);
  font-size: 13px;
  cursor: default;

  .anticon {
    font-size: 15px;
  }

  span {
    font-size: 12px;
    font-weight: 500;
  }
`;

/* ─── Mobile Card List ─── */

export const MobileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MobileCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.15s;

  &:active {
    background: #fafafa;
    transform: scale(0.99);
  }
`;

export const MobileCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const MobileCardProtocol = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.75);
  font-variant-numeric: tabular-nums;
`;

export const MobileCardDate = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
`;

export const MobileCardBody = styled.div`
  margin-bottom: 10px;
`;

export const MobileCardSummary = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 2px;
`;

export const MobileCardSub = styled.div`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MobileCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MobileCardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const MobileAttachment = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.3);

  .anticon {
    font-size: 14px;
  }
`;

export const MobileFab = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--primary);
  color: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(24, 144, 255, 0.4);
  z-index: 100;
  transition: all 0.2s;

  &:active {
    transform: scale(0.92);
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;
